<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                {{ poiType.id ? $t('poiType.form.editTitle') : $t('poiType.form.newTitle') }}
              </div>
            </div>
            <hr style="margin-top: -4px" />
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label for="Name">
                        <span class="required">*</span> {{ $t('poiType.form.nameLabel') }}
                      </label>
                      <input
                        autocomplete="new-password"
                        type="text"
                        id="Name"
                        class="form-control"
                        v-model="poiType.name"
                        placeholder=""
                      />
                    </div>
                    <div class="form-group col-md-6">
                      <label for="inputStatus">
                        <span class="required">*</span> {{ $t('common.status') }}
                      </label>
                      <select
                        id="inputStatus"
                        v-model="poiType.status"
                        class="form-control"
                      >
                        <option :value="1">{{ $t('common.active') }}</option>
                        <option :value="0">{{ $t('common.inactive') }}</option>
                      </select>
                    </div>
                  </div>

                  <div v-if="poiType.id" class="form-group mt-2">
                    <label>{{ $t('poiType.form.mapPinLabel') }}</label>
                    <div class="d-flex align-items-center" style="gap: 12px">
                      <div>
                        <img
                          v-if="poiType.pin_icon"
                          :src="poiType.pin_icon"
                          style="
                            width: 48px;
                            height: 48px;
                            object-fit: contain;
                            border: 1px solid #ddd;
                            border-radius: 6px;
                          "
                        />
                        <div v-else class="pin-empty-preview">
                          {{ $t('poiType.form.noPinLine1') }}<br />{{ $t('poiType.form.noPinLine2') }}
                        </div>
                      </div>
                      <div>
                        <label
                          v-if="$hasAbility('cadastro.gerenciar')"
                          class="btn btn-sm btn-outline-primary mb-1"
                          style="cursor: pointer"
                        >
                          <feather-icon icon="UploadIcon" size="14" /> {{ $t('poiType.form.uploadPinButton') }}
                          <input
                            type="file"
                            accept="image/*"
                            style="display: none"
                            @change="uploadPin"
                          /> </label
                        ><br />
                        <a
                          v-if="poiType.pin_icon && $hasAbility('cadastro.gerenciar')"
                          href="#"
                          class="text-danger small"
                          @click.prevent="removePin"
                          >{{ $t('poiType.form.removePinLink') }}</a
                        >
                      </div>
                    </div>
                    <small class="text-muted">{{ $t('poiType.form.pinHint') }}</small>
                  </div>

                  <!-- Editor de campos dinâmicos -->
                  <div class="card mt-3">
                    <div
                      class="card-header d-flex justify-content-between align-items-center py-2"
                    >
                      <span class="font-weight-bold"
                        >{{ $t('poiType.form.fieldsSectionTitle') }}</span
                      >
                      <b-button size="sm" variant="success" @click="addField"
                        >{{ $t('poiType.form.addFieldButton') }}</b-button
                      >
                    </div>
                    <div class="card-body p-2">
                      <div
                        v-for="(field, index) in fieldSchema"
                        :key="index"
                        class="border rounded p-2 mb-2 bg-light"
                      >
                        <div class="form-row align-items-end">
                          <div class="form-group col-md-2 mb-1">
                            <label class="small mb-0">{{ $t('poiType.form.fieldKeyLabel') }}</label>
                            <input
                              type="text"
                              class="form-control form-control-sm"
                              v-model="field.key"
                              placeholder="ex: rtsp_url"
                            />
                          </div>
                          <div class="form-group col-md-3 mb-1">
                            <label class="small mb-0">{{ $t('poiType.form.fieldLabelLabel') }}</label>
                            <input
                              type="text"
                              class="form-control form-control-sm"
                              v-model="field.label"
                              placeholder="ex: URL do stream"
                            />
                          </div>
                          <div class="form-group col-md-2 mb-1">
                            <label class="small mb-0">{{ $t('poiType.form.fieldTypeLabel') }}</label>
                            <select
                              class="form-control form-control-sm"
                              v-model="field.type"
                              @change="onFieldTypeChange(field)"
                            >
                              <option value="text">{{ $t('poiType.form.fieldTypeText') }}</option>
                              <option value="number">{{ $t('poiType.form.fieldTypeNumber') }}</option>
                              <option value="textarea">{{ $t('poiType.form.fieldTypeTextarea') }}</option>
                              <option value="select">{{ $t('poiType.form.fieldTypeSelect') }}</option>
                            </select>
                          </div>
                          <div class="form-group col-md-2 mb-1">
                            <label class="small mb-0">{{ $t('poiType.form.fieldColLabel') }}</label>
                            <select
                              class="form-control form-control-sm"
                              v-model="field.col"
                            >
                              <option value="col-md-3">3 (25%)</option>
                              <option value="col-md-4">4 (33%)</option>
                              <option value="col-md-6">6 (50%)</option>
                              <option value="col-md-12">12 (100%)</option>
                            </select>
                          </div>
                          <div class="form-group col-md-2 mb-1">
                            <label class="small mb-0">{{ $t('poiType.form.fieldRequiredLabel') }}</label>
                            <select
                              class="form-control form-control-sm"
                              v-model="field.required"
                            >
                              <option :value="false">{{ $t('poiType.form.no') }}</option>
                              <option :value="true">{{ $t('poiType.form.yes') }}</option>
                            </select>
                          </div>
                          <div class="form-group col-md-1 mb-1 text-right">
                            <label class="small mb-0 d-block">&nbsp;</label>
                            <b-button
                              size="sm"
                              variant="danger"
                              @click="removeField(index)"
                              >✕</b-button
                            >
                          </div>
                        </div>
                        <!-- Opções do select -->
                        <div v-if="field.type === 'select'" class="mt-2">
                          <label class="small mb-1 font-weight-bold"
                            >{{ $t('poiType.form.selectOptionsLabel') }}</label
                          >
                          <div
                            v-for="(opt, optIndex) in field.options"
                            :key="optIndex"
                            class="d-flex align-items-center mb-1"
                          >
                            <input
                              type="text"
                              class="form-control form-control-sm mr-1"
                              v-model="field.options[optIndex]"
                              :placeholder="$t('poiType.form.optionPlaceholder') + ' ' + (optIndex + 1)"
                            />
                            <b-button
                              size="sm"
                              variant="outline-danger"
                              @click="field.options.splice(optIndex, 1)"
                              >✕</b-button
                            >
                          </div>
                          <b-button
                            size="sm"
                            variant="outline-secondary"
                            @click="field.options.push('')"
                            >{{ $t('poiType.form.addOptionButton') }}</b-button
                          >
                        </div>
                      </div>
                      <p v-if="!fieldSchema.length" class="text-muted small mb-0">
                        {{ $t('poiType.form.noFieldsDefined') }}
                      </p>
                    </div>
                  </div>

                  <span class="required_fields">
                    <span class="required">*</span>
                    <strong>{{ $t('poiType.form.requiredFieldsNote') }}</strong>
                  </span>
                  <div class="block text-right">
                    <router-link to="/poi_types" class="btn btn-back mr-1">
                      <i class="fa fa-arrow-left"></i> {{ $t('common.back') }}
                    </router-link>
                    <a v-if="$hasAbility('cadastro.gerenciar')" class="btn btn-add" @click="save">
                      {{ $t('common.save') }}
                      <i class="fa fa-save"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";
import Loading from "vue-loading-overlay";
import { BButton } from "bootstrap-vue";

export default {
  data() {
    return {
      poiType: {
        name: "",
        status: 1,
      },
      fieldSchema: [],
    };
  },
  computed: {},
  methods: {
    addField() {
      this.fieldSchema.push({
        key: "",
        label: "",
        type: "text",
        required: false,
        col: "col-md-6",
        options: [],
      });
    },

    removeField(index) {
      this.fieldSchema.splice(index, 1);
    },

    onFieldTypeChange(field) {
      if (field.type !== "select") {
        field.options = [];
      }
    },

    save: function () {
      const self = this;
      let api = self.$store.state.api + "poi_types";

      self.poiType.field_schema = self.fieldSchema.length
        ? self.fieldSchema
        : null;

      if (self.poiType.id) {
        self.poiType._method = "PUT";
        api += "/" + self.poiType.id;
      }

      self.$loading(true);

      axios
        .post(api, self.poiType)
        .then(() => {
          self.$message(
            self.$t("poiType.messages.saveSuccessTitle"),
            self.$t("poiType.messages.saveSuccessMessage"),
            "success"
          );
          self.$loading(false);
          this.$router.push("/poi_types");
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
    uploadPin(event) {
      const file = event.target.files[0];
      if (!file || !this.poiType.id) return;
      const fd = new FormData();
      fd.append("pin", file);
      this.$loading(true);
      axios
        .post(
          this.$store.state.api + "poi_types/" + this.poiType.id + "/pin",
          fd
        )
        .then((r) => {
          this.$set(this.poiType, "pin_icon", r.data.pin_url);
          this.$message(
            this.$t("poiType.messages.saveSuccessTitle"),
            this.$t("poiType.messages.pinUpdated"),
            "success"
          );
        })
        .catch(() =>
          this.$message(null, this.$t("poiType.messages.pinUploadError"), "error")
        )
        .finally(() => {
          this.$loading(false);
          event.target.value = "";
        });
    },
    removePin() {
      if (!this.poiType.id) return;
      this.$loading(true);
      axios
        .delete(this.$store.state.api + "poi_types/" + this.poiType.id + "/pin")
        .then(() => {
          this.$set(this.poiType, "pin_icon", null);
          this.$message(
            this.$t("poiType.messages.saveSuccessTitle"),
            this.$t("poiType.messages.pinRemoved"),
            "success"
          );
        })
        .catch(() =>
          this.$message(null, this.$t("poiType.messages.pinRemoveError"), "error")
        )
        .finally(() => this.$loading(false));
    },
    getPoiType: function (id) {
      const self = this;
      const api = self.$store.state.api + "poi_types/" + id;
      self.$loading(true);

      axios
        .get(api)
        .then((response) => {
          const data = response.data.data[0];
          self.poiType = data;
          self.fieldSchema = data.field_schema || [];
          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;

    let id = self.$route.params.id;
    if (id) {
      self.getPoiType(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
    BButton,
    Loading,
  },
};
</script>
<style scoped>
.custom-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 255, 128, 0);
  backdrop-filter: blur(3px);
  opacity: 0.98;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.custom-loading-spinner {
  width: 100px;
  height: 100px;
  z-index: 10000;
}
.pin-empty-preview {
  width: 48px;
  height: 48px;
  border: 1px dashed #ccc;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 9px;
  color: #999;
  line-height: 1.1;
}
</style>
